// extracted by mini-css-extract-plugin
export default {"menuBlock":"BF-z","title":"CF-z","nav":"DF-z","flexCell":"EF-z","facetLink":"FF-z"};